import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import EnchrochmentSidebar from "../../EnchrochmentSidebar/EnchrochmentSidebar";
import ViewURL from "./Modal/ViewURL";
import UploadComplaintSharePopup from "./Modal/UploadComplaintSharePopup";
import { ZoneNameCommanDDL } from "../../../../../../../Components/IllegalDDL/ZoneNameCommanDDL";
import { HeaderIllegal } from "../../../IllegalConstructionDashboard/HeaderIllegal";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../../../Helper/Context";
import { useSearchParams } from "react-router-dom";
import { Pegination } from "../../../../../../../Components/Pegination/Pegination";
import moment from "moment"
import { UploadedComplaintTableDataAPI } from "../../../../../../../Redux/EnchrochmentDashboardSlice/ReceivedComplaintsSocialMediaSlice/UploadedComplaintSlice";

export const UploadComplaintGrid = () => {
    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails


    const [searchParams] = useSearchParams()

    // let YearValue = searchParams.get("YearValue")
    // let MonthValue = searchParams.get("MonthValue")
    // let ZoneValue = searchParams.get("ZoneValue");
    let DashSelect = searchParams.get("DashSelect");

    const { t } = useTranslation()
    const [isopen, setIsOpen] = useState(false);
    const toggle = () => {
        setIsOpen(!isopen);
    };

    const [IsPost, setIsPost] = useState(false)
    const [loader, setloader] = useState(false)

    const [IsClear, setIsClear] = useState(false)
    const [IsSearch, setIsSearch] = useState(false)

    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [showImagePopup, setshowImagePopup] = useState(false)

    const [FromDate, setFromDate] = useState('')
    const [ToDate, setToDate] = useState('')

    // ------------header DDL ------------

    const [YearValue, setYearValue] = useState(sessionStorage.getItem('yearId'))
    const [YearLabel, setYearLabel] = useState(sessionStorage.getItem('yearLable'))
    const [MonthValue, setMonthValue] = useState(sessionStorage.getItem('monthId'))
    const [MonthLabel, setMonthLabel] = useState(sessionStorage.getItem('monthLable'))
    const [ZoneValue, setZoneValue] = useState(sessionStorage.getItem('zoneId'))
    const [ZoneLabel, setZoneLabel] = useState(sessionStorage.getItem('ZoneLable'))

    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setFromDate('')
        setToDate('')
        setZoneNameID({
            ...ZoneNameID,
            ID: 0,
            Label: 'Select...'
        })
    }
    const [DashType, setDashType] = useState(localStorage.getItem('DashType') ? localStorage.getItem('DashType') : 1)

    useEffect(() => {
        setLanguage({
            ...Language,
            DDL: [],
            ID: 0,
            Label: localStorage.getItem('LanguageChange'),
        })
    }, [])


    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: sessionStorage.getItem('LanguageChange')
    })

    const [ZoneNameID, setZoneNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const DataObj = ({
        isCountLoading: '',
        Language: Language.Label
    })
    const [SharePopUpShow, setSharePopUpShow] = useState(false)

    const handleShare = () => {
        setSharePopUpShow(!SharePopUpShow)
    }

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    useEffect(() => {
        const data = {
            M_FinacialYearID: YearValue,
            M_MonthID: MonthValue,
            FromDate: FromDate,
            ToDate: ToDate,
            M_ZoneID: ZoneNameID.ID ? ZoneNameID.ID : ZoneValue,
            M_WardID: 0,
            T_ComplaintDetailsID: 0,
            M_WorkTypeID: DashSelect,
            Language: Language.Label,
            M_UserID: UserID,
            FromTop: From,
            ToTop: To,
            token: token,
            Flag: 'Upload_Complaint',
        }
        if (Language.Label != null) {
            dispatch(UploadedComplaintTableDataAPI({ data }))
        }
    }, [YearValue, MonthValue, From, IsClear, IsSearch, IsPost, Language.Label, FromDate, ToDate, ZoneValue, ZoneNameID.ID])

    const { isLoading, tableData } = useSelector(state => state.UploadedComplaintTableData)


    return (
        <>
            <HeaderIllegal />
            <div className="wrapper bg-change">
                <EnchrochmentSidebar
                />
                <div className="content1 content mt-1 " style={{}}>

                    <div className="row">
                        <div className="col-12">
                            {/* Upload Complaint */}
                            <h5 className="text-dark fw-bold ps-3 pt-3 all_heading_fontsize">{t('EncroachmentDashboard.Uploadcomplaint')}
                                {/* <span className="float-end add_btn">Add</span> */}
                                {/* <span className="add_btn  float-end cursor-pointer" onClick={() => {
                                                handleAddDepartment(true)
                                            }}
                                                title="Add">
                                                <i class="fa-solid fa-plus pe-1"></i> Add
                                            </span> */}
                            </h5>
                        </div>
                    </div>
                    <div className="row ps-3 pt-2 eic_table_styles" >

                        <div class="col-12 col-lg-3 pt-2">

                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.FromDate')}</label><br />
                            <input
                                className="form-control"
                                id="FromDate"
                                type="date"
                                name="FromDate"
                                value={FromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                            />
                        </div>

                        <div class="col-12 col-lg-3 pt-2">

                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.ToDate')}</label><br />
                            <input
                                className="form-control"
                                id="ToDate"
                                type="date"
                                name="ToDate"
                                value={ToDate}
                                onChange={(e) => setToDate(e.target.value)}
                                min={FromDate}
                            />
                        </div>


                        <div class="col-12 col-lg-3 pt-2">
                            <ZoneNameCommanDDL
                                ZoneNameID={ZoneNameID}
                                setZoneNameID={setZoneNameID}
                                Flag='Insert'
                                ApiFlag='UserWiseZone'
                                data=''
                                IsPost=''
                                Language={Language}
                                ZoneValue={ZoneValue}
                                ZoneLabel={ZoneLabel}
                            />
                        </div>

                        <div className="col-12 col-lg-3 col-md-4 mt-3">

                            {/* <button type="button" className="btn btn-success mx-3">Search</button> */}
                            <button type="button" className="btn btn-danger mt-4" onClick={handleClear}>Clear</button>
                        </div>

                        <div className="row" >
                            <div className="col-12  " >
                                <div className="table-responsive pt-3">
                                    <table className="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.UploadComplaintDate')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ZoneName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.WardName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Area')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.UploadComplaintPhoto')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Remark')}</th>
                                                {/* <th className="text-center">{t('EncroachmentDashboard.Action')}</th> */}
                                            </tr>

                                        </thead>
                                        <tbody>
                                            {
                                                tableData && tableData?.length > 0 ? tableData?.map((i, j) => {
                                                    return (
                                                        <tr>
                                                            <td className="py-1" align="center">{i.rowNum}</td>
                                                            <td className="nowrap">{i.uploadDate ? moment(i.uploadDate).format("DD-MM-YYYY") : '-'}</td>
                                                            <td >{i.zoneName ? i.zoneName : '-'}</td>
                                                            <td >{i.wardName ? i.wardName : '-'}</td>
                                                            <td >{i.encroachmentArea ? i.encroachmentArea : '-'}</td>


                                                            <td className="text-center">
                                                                {
                                                                    (i.uploadPhoto == null) ?
                                                                        <span>-</span>
                                                                        :
                                                                        <button className="view_button " onClick={() => handleShowImage(i.uploadPhoto)}>
                                                                            {t('EncroachmentDashboard.View')}
                                                                        </button>
                                                                }

                                                            </td>

                                                            <td >{i.uploadRemark ? i.uploadRemark : '-'}</td>

                                                            {/* <td className="text-center">

                                                                <span className=""
                                                                    onClick={() => {
                                                                        handleShare()
                                                                    }}
                                                                    title="Share">
                                                                    <i className="fa-solid fa-share-from-square mx-2 text-success cursor-pointer"></i>
                                                                </span>



                                                            </td> */}

                                                        </tr>
                                                    )
                                                })
                                                    :
                                                    <tr>
                                                        <td colSpan={10}>No data found ...</td>
                                                    </tr>
                                            }



                                        </tbody>
                                    </table>
                                </div>
                                {tableData && tableData.length > 0 &&
                                    <Pegination
                                        PerPageCount={PerPageCount}
                                        TotalCount={tableData && tableData[0].totalCount}
                                        setFrom={setFrom}
                                        setTo={setTo}
                                        CurrentPage={CurrentPage}
                                        setCurrentPage={setCurrentPage}
                                        IsClear={IsClear}
                                    />
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {
                showImagePopup ?
                    <ViewURL
                        Heading={t('EncroachmentDashboard.View')}
                        setshowImagePopup={setshowImagePopup}
                        ImagePopUpData={ImagePopUpData}

                    />
                    : ''
            }

            {SharePopUpShow ?
                <UploadComplaintSharePopup
                    message="Add"
                    handleShare={handleShare}
                // heading="Forward"
                // cancelBtnCallBack={handleAddDepartment}
                /> : <></>
            }

        </>
    )
}

